import { Toaster } from '@/components/ui/toaster';
import ScrollToTop from '@/lib/ScrollToTop';
import { queryClientInstance } from '@/lib/query-client';
import { QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import PageNotFound from './lib/PageNotFound';
import { pagesConfig } from './pages.config';

const PageFallback = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-[#173C35]">
    <div className="w-8 h-8 border-4 border-white/20 border-t-white rounded-full animate-spin" />
  </div>
);

function App() {
  const { Pages, Layout, mainPage } = pagesConfig;
  const mainPageKey = mainPage ?? (Pages ? Object.keys(Pages)[0] : null);
  const MainPage = mainPageKey ? Pages[mainPageKey] : () => <></>;

  const LayoutWrapper = ({ children, currentPageName }) =>
    Layout ? <Layout currentPageName={currentPageName}>{children}</Layout> : <>{children}</>;
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClientInstance}>
        <Router>
          <ScrollToTop />
          <Suspense fallback={<PageFallback />}>
            <Routes>
              <Route
                path="/"
                element={
                  <LayoutWrapper currentPageName={mainPageKey}>
                    <MainPage />
                  </LayoutWrapper>
                }
              />
              {Pages &&
                Object.entries(Pages).map(([path, Page]) => (
                  <Route
                    key={path}
                    path={`/${path}`}
                    element={
                      <LayoutWrapper currentPageName={path}>
                        <Page />
                      </LayoutWrapper>
                    }
                  />
                ))}
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </Suspense>
        </Router>
        <Toaster />
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
